const home = {
  'admin.home.hetmet': 'Trang chủ - Bảng tin',
};

export default {
  ...home,
};
